import { OracleSupportedSymbol } from "@ui/services/oracle/latest-price/types";
import { HermsSupportedSymbol } from "@ui/services/pyth-hermes/constants";
import { ChainName } from "@ui/types/chain";
import { Nullable } from "@ui/types/utility";
import BigNumber from "bignumber.js";

export type SupportedSymbol =
  | HermsSupportedSymbol
  | OracleSupportedSymbol
  | 'WRAPPED_NATIVE'
  | 'LVUSD'
  | 'LVMON'
  | 'LV'
  | 'Rona'
  | 'EMO';

export const SAME_PRICE_MAP: Partial<
  Record<SupportedSymbol, SupportedSymbol[]>
> = {
  MON: ['WMON'], // MON price from herms
} as const;

export const WRAPPED_NATIVE_MAP: Record<ChainName, SupportedSymbol> = {
  [ChainName.MONAD]: 'MON',
  [ChainName.MONAD_TESTNET]: 'MON',
};

type PriceRecord = Record<SupportedSymbol, Nullable<BigNumber>>;

type PriceState = {
  priceRecord: PriceRecord | undefined;
  setPrice: (asset: SupportedSymbol, price: BigNumber) => void;
};